var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-tree-wrapper"},[_c('el-tree',{ref:"mylist",attrs:{"data":_vm.list,"props":_vm.defaultProps,"render-content":_vm.renderContent,"default-expand-all":"","current-node-key":_vm.currentKey,"highlight-current":"","node-key":"id","default-expanded-keys":_vm.defaultExpandedKeys},on:{"node-click":_vm.handleTreeMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }